module.exports = __webpack_public_path__ + "img/kgc-logo-weiss.c9898b5d.svg";